import type { ConsentState, ConsentUiMode } from "./types";

export type ConsentUiVisibility = "hidden" | "prompt" | "preferences";

type ConsentUiDecision = {
  state: ConsentState;
  mode?: ConsentUiMode;
  gpc: boolean;
  dnt: boolean;
  isShopify: boolean;
  hasHostCmp: boolean;
  forceOpen?: boolean;
  showPreferencesButton?: boolean;
};

export function resolveConsentUiVisibility({
  state,
  mode = "auto",
  gpc,
  dnt,
  isShopify,
  hasHostCmp,
  forceOpen = false,
  showPreferencesButton = true,
}: ConsentUiDecision): ConsentUiVisibility {
  if (mode === "host" || isShopify || gpc || dnt) return "hidden";
  if (mode === "auto" && hasHostCmp) return "hidden";
  if (forceOpen || state === "unknown") return "prompt";
  return showPreferencesButton ? "preferences" : "hidden";
}

export function sanitizePrivacyUrl(
  value: unknown,
  baseUrl: string,
): string | undefined {
  if (typeof value !== "string" || !value.trim()) return undefined;
  try {
    const url = new URL(value, baseUrl);
    return url.protocol === "http:" || url.protocol === "https:"
      ? url.toString()
      : undefined;
  } catch {
    return undefined;
  }
}
